import { ValidationObserver, ValidationProvider } from 'vee-validate';
import UserService from '../../services/user/UserService';
import i18n from '../../i18n';
import { mapState } from "vuex";

export default {
  data() {
    return {
      b:3,
      identificationType: null,
      identification: null,
      name: null,
      email: null,
      cellphone: null,
      address: null,
      numberOne: null,
      isDisabled:true,
      numberTwo: null,
      numberThree: null,
      complementOne: null,
      complementTwo: null,
      blockOrInside: null,
      propertyType: null,
      addressA: [
        {
          name: "Anillo",
          id: 1
        },
        {
          name: "Autopista",
          id: 2
        },
        {
          name: "Avenida",
          id: 3
        },
        {
          name: "Avenida Calle",
          id: 4
        },
        {
          name: "Avenida Carrera",
          id: 5
        },
        {
          name: "Calle",
          id: 6
        },
        {
          name: "Carrera",
          id: 7
        },
        {
          name: "Circular",
          id: 8
        },
        {
          name: "Diagonal",
          id: 9
        },
        {
          name: "Transversal",
          id: 10
        },
        {
          name: "Zona",
          id: 11
        }
      ],
      propertyTypes: [
        {
          name: "-Tipo de inmueble-",
          id: 1
        },
        {
          name: "Urbanización",
          id: 2
        },
        {
          name: "Oficina",
          id: 3
        },
        {
          name: "Hotel",
          id: 4
        },
        {
          name: "Edificio",
          id: 5
        },
        {
          name: "Casa",
          id: 6
        }
      ],
      blockOrInsides: [
        {
          name: "-Bloque o interior-",
          id: 1
        },
        {
          name: "Piso",
          id: 2
        },
        {
          name: "Apartamento",
          id: 3
        },
        {
          name: "Habitación",
          id: 4
        },
        {
          name: "Bloque",
          id: 5
        },
        {
          name: "Zona",
          id: 6
        },
        {
          name: "Manzana",
          id: 7
        }
      ]
    }
  },
  computed: {
    ...mapState('auth', {
      user: 'user'
    }),
  },

  created() {
    this.getData();
  },


  methods: {
    modificacionDatos(campo,event){

      if(campo == "email" && this.email != event || campo == "cellphone" && this.cellphone != event || campo == "nameNomenclature" && this.nameNomenclature != event 
      || campo == "numberOne" && this.numberOne != event|| campo == "numberTwo" && this.numberTwo != event|| 
      campo == "numberThree" && this.numberThree != event|| campo == "propertyType" && this.propertyType != event|| 
      campo == "complementOne" && this.complementOne != event|| campo == "complementTwo" && this.complementTwo != event||
       campo == "blockOrInside" && this.blockOrInside != event ){
        this.isDisabled = true;
      }else{
        this.isDisabled = false;
      }
      
  },
   
    async getData() {
      try {
        const body = {
          identification: this.user.identification
        }
        const response = await UserService.getOne(body);
        this.identification = response.data.identification
        this.identificationType = response.data.idIdentificationType.name
        this.name = response.data.name
        this.email = response.data.email
        this.cellphone = response.data.cellPhone
        this.address = response.data.address
        this.nameNomenclature = response.data.addressNomenclature
        this.numberOne = response.data.addressNumberOne
        this.numberTwo = response.data.addressNumberTwo
        this.numberThree = response.data.addressNumberThree
        this.complementOne = response.data.addressTypePropertyValue
        this.complementTwo = response.data.addressBlockOrInteriorValue
        this.blockOrInside = response.data.addressBlockOrInterior
        this.propertyType = response.data.addressTypeProperty
      } catch (error) {
        this.showToast('Error consultando la información de usuario', 'is-warning')
      }
    },

    onlyNumberAndLetters(e) {
      if (e.key.match(/[a-z0-9ñçáéíóú\s]/i) === null) {
        e.preventDefault();
      }
    },

    filterKey(e) {
      const key = e.key;
      if (/[A-Za-z- ]/.test(key))
        console.log("Positivo");
      else
        return e.preventDefault();
    },

    filterKeyCount(e) {
      const key = e.key;
      if (/[0-9]/.test(key)) { } else {
        return e.preventDefault();
      }
    },

    async save() {
      try {

        if (this.cellphone[0] != '3') {
          this.$buefy.toast.open({
            duration: 2000,
            message: `El número celular debe empezar con el número 3`,
            type: 'is-danger'
          })
          return
        }

        if (this.cellphone.length < 10) {
          this.$buefy.toast.open({
            duration: 2000,
            message: `El número celular debe tener 10 dígitos`,
            type: 'is-danger'
          })
          return
        }
        
        const body = {
          identification: this.user.identification,
          cellphone: this.cellphone,
          email : this.email,
          addressNomenclature: this.nameNomenclature,
          addressNumberOne: this.numberOne,
          addressNumberTwo: this.numberTwo,
          addressNumberThree: this.numberThree,
          addressTypePropertyValue: this.complementOne,
          addressBlockOrInteriorValue: this.complementTwo,
          addressBlockOrInterior: this.blockOrInside,
          addressTypeProperty: this.propertyType
        }

        const response = await UserService.saveProfile(body)
        
        this.showToast('Información actualizada', 'is-success')
          
      } catch (error) {
        this.showToast('Hubo un error procesando la petición', 'is-danger')
      }

    },

    showToast(message, type) {
      this.$buefy.toast.open({ message, type })
    }
  }
}
